import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "dat-tutoring-landing" */ './DATTutoringLandingPage'));
